import React, {useEffect, useMemo} from 'react';
import './App.scss';
import AppRouter from './router/AppRouter';
import Features from './services/config/feature';
import { Helmet } from 'react-helmet-async';
import { DEFAULT_TITLE } from 'utils/constants';

function App() {
    const initFeatures = () => {
        localStorage.setItem('flags', JSON.stringify(Features));
    };
    initFeatures();
    useMemo(() => {
        let route = window?.location.pathname + window.location.search;
        if (
            route?.includes('company') ||
            route?.includes('industry') ||
            route?.includes('screener') ||
            route?.includes('watchlist') ||
            route?.includes('network') ||
            route?.includes('disclaimer') ||
            route?.includes('landingpage') ||
            route === '/insightsdirect/' ||
            route?.includes('corporateaccess')
        ) {
            localStorage.setItem('redirectRoute', route);
        }
    }, []);

    return (
        <>
        <Helmet>
            <title>{DEFAULT_TITLE}</title>
        </Helmet>
        <div className="App">
            <AppRouter />
        </div>
    </>);
}

export default App;
